<template>
  <div class="min-max-chart"></div>
</template>

<script>
  export default {
    props: {
      xaxisData: {
        type: Array,
        required: true,
      },
      minMaxData: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        target: undefined,
      };
    },
    mounted() {
      this.buildChart();
      this.target.setSize(null);
    },

    methods: {
      buildChart() {
        this.target = Highcharts.chart(this.$el, {
          chart: {
            type: 'column',
            reflow: true,
          },
          title: {
            // text: 'Max/Min Points',
            text: 'Max Points',
            style: {
              fontWeight: 'bold',
              fontSize: '20px',
            },
          },
          xAxis: {
            categories: this.xaxisData,
            labels: {
              formatter() {
                return this.value[0];
              },
            },
          },
          yAxis: {
            title: {
              text: 'Points',
            },
          },

          tooltip: {
            formatter() {
              this.name = this.key.slice(1);
              return this.name;
            },
          },
          legend: {
            enabled: false,
          },

          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
              },
            },
          },
          series: this.minMaxData,
          credits: {
            enabled: false,
          },
        });
      },
    },

    beforeDestroy() {
      if (this.target) this.target.destroy();
    },
  };
</script>
<style lang="scss" scoped>
  .min-max-chart {
    width: 100%;
    max-width: 600px;
  }
</style>
